/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Luci_Shopping_Api_Models_BillingAddress } from './Luci_Shopping_Api_Models_BillingAddress';
import type { Luci_Shopping_Api_Models_ShippingAddress } from './Luci_Shopping_Api_Models_ShippingAddress';
export type Luci_Shopping_Api_Requests_CheckOutWebOrderRequest = {
  deliveryMethod?: Luci_Shopping_Api_Requests_CheckOutWebOrderRequest.deliveryMethod;
  billingAddress: Luci_Shopping_Api_Models_BillingAddress;
  shippingAddress?: Luci_Shopping_Api_Models_ShippingAddress;
  paymentToken?: string;
  sessionId?: string;
  paymentAttemptId?: string;
  utcOffsetInMinutes?: number;
  customerEmailAddress?: string;
  customerPhoneNumber?: string;
};
export namespace Luci_Shopping_Api_Requests_CheckOutWebOrderRequest {
  export enum deliveryMethod {
    POINT_OF_SALE = 'PointOfSale',
    SHIPPING = 'Shipping',
    PICKUP = 'Pickup',
  }
}

